import React from "react";

function StatCard({ icon, label, value, accent }) {
  return (
    <div className="profile-stat">
      <div className="ps-icon" style={{ color: accent || "var(--accent-light)", background: accent ? `${accent}18` : "var(--accent-glow)" }}>
        {icon}
      </div>
      <div className="ps-val">{value}</div>
      <div className="ps-label">{label}</div>
    </div>
  );
}

function InfoRow({ label, value, mono }) {
  return (
    <div className="info-row">
      <span className="info-label">{label}</span>
      <span className={`info-val ${mono ? "mono" : ""}`}>{value || <span className="info-empty">Not set</span>}</span>
    </div>
  );
}

function Profile({ passenger, bookings }) {
  const totalSpent = bookings.reduce((s, b) => s + b.total, 0);
  const airlines = [...new Set(bookings.map((b) => b.airline))];
  const joined = new Date().toLocaleDateString("en-IN", { month: "long", year: "numeric" });

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-h1">Profile</h1>
          <p className="page-desc">Your traveller identity and account overview.</p>
        </div>
      </div>

      {/* Hero Card */}
      <div className="profile-hero">
        <div className="profile-avatar-wrap">
          <div className="profile-avatar">
            {passenger.name
              ? passenger.name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()
              : "WA"}
          </div>
          <div className="profile-online-dot" />
        </div>
        <div className="profile-hero-info">
          <div className="profile-name">{passenger.name || "Wuna Akhilesh"}</div>
          <div className="profile-email">{passenger.email || "wunaakhilesh2209@gmail.com"}</div>
          <div className="profile-tags">
            <span className="profile-tag profile-tag--gold">Premium Member</span>
            <span className="profile-tag">Verified</span>
          </div>
        </div>
        <div className="profile-member-since">
          <div className="pms-label">Member since</div>
          <div className="pms-val">{joined}</div>
        </div>
      </div>

      {/* Stats Row */}
      <div className="profile-stats">
        <StatCard
          icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M17.8 19.2L16 11l3.5-3.5C21 6 21 4 19 4c-2 0-4 1-3.5 2.5L12 10 4.8 6.2c-.5-.3-1.1 0-1.2.5L3 8c-.1.5.2 1 .7 1.2L9 11.5 6.5 14H4l-1 2 2 1 1-2h2.5L11.5 17.5l-2.5.8c-.4.1-.7.6-.7 1.1l.2 1.2c.1.5.7.8 1.2.5L19 16l-.2 3.2z"/></svg>}
          label="Flights Taken"
          value={bookings.length}
        />
        <StatCard
          icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>}
          label="Total Spent"
          value={totalSpent > 0 ? `₹${totalSpent.toLocaleString()}` : "₹0"}
          accent="#10b981"
        />
        <StatCard
          icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>}
          label="Airlines Used"
          value={airlines.length || 0}
          accent="#8b5cf6"
        />
        <StatCard
          icon={<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>}
          label="Loyalty Points"
          value={bookings.length * 250}
          accent="#f59e0b"
        />
      </div>

      {/* Info Grid */}
      <div className="profile-grid">
        <div className="page-card">
          <div className="page-card-header">
            <div className="page-card-icon">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            Personal Information
          </div>
          <div className="info-rows">
            <InfoRow label="Full Name" value={passenger.name || "Wuna Akhilesh"} />
            <InfoRow label="Email" value={passenger.email || "wunaakhilesh2209@gmail.com"} />
            <InfoRow label="Phone" value={passenger.phone || "+91 7842727605"} />
            <InfoRow label="Nationality" value="Indian" />
            <InfoRow label="Member Tier" value="Premium" />
          </div>
        </div>

        <div className="page-card">
          <div className="page-card-header">
            <div className="page-card-icon page-card-icon--green">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
            </div>
            Travel Preferences
          </div>
          <div className="info-rows">
            <InfoRow label="Preferred Class" value="Economy" />
            <InfoRow label="Seat Preference" value="Window" />
            <InfoRow label="Meal Preference" value="Vegetarian" />
            <InfoRow label="Frequent Flyer No." value="—" />
          </div>
        </div>

        {airlines.length > 0 && (
          <div className="page-card">
            <div className="page-card-header">
              <div className="page-card-icon page-card-icon--purple">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17.8 19.2L16 11l3.5-3.5C21 6 21 4 19 4c-2 0-4 1-3.5 2.5L12 10 4.8 6.2c-.5-.3-1.1 0-1.2.5L3 8c-.1.5.2 1 .7 1.2L9 11.5 6.5 14H4l-1 2 2 1 1-2h2.5L11.5 17.5l-2.5.8c-.4.1-.7.6-.7 1.1l.2 1.2c.1.5.7.8 1.2.5L19 16l-.2 3.2z"/>
                </svg>
              </div>
              Airlines Flown
            </div>
            <div style={{ padding: "12px 20px 20px", display: "flex", gap: 8, flexWrap: "wrap" }}>
              {airlines.map((a) => (
                <span key={a} style={{
                  fontSize: 12, fontWeight: 600, padding: "5px 12px",
                  background: "var(--accent-glow)", border: "1px solid rgba(59,130,246,0.25)",
                  color: "var(--accent-light)", borderRadius: 100,
                }}>
                  {a}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Profile;